import styled, { AnyStyledComponent, css } from 'styled-components';
import { Button, Fonts } from '@bimone/bimtrackreactcomponents';
import { ReactComponent as Logo } from '../../assets/images/bimtrack-horizontal-logo.svg';
import 'simplebar/dist/simplebar.css';
import ScrollableContainer from '../../components/scrollableContainer/ScrollableContainer';

export const StyledErrorPage = {
  Background: styled.div`
    height: 100vh;
    width: 100vw;
    display: flex;
    justify-content: center;
    align-items: center;
    ${({ theme: { colors } }) => css`
      background: ${colors.grey.lightest};
    `};
  `,
  Container: styled.div`
    height: 65vh;
    width: 75vw;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    overflow: hidden;
    ${({ theme: { colors, metrics } }) => css`
      background: ${colors.white};
      box-shadow: 0 0 ${metrics.rem(6)} 0 ${colors.addOpacity(colors.black, 0.04)},
        0 ${metrics.rem(6)} ${metrics.rem(60)} 0 ${colors.addOpacity(colors.black, 0.1)};

      & > * {
        margin-left: ${metrics.rem(8)};
        margin-right: ${metrics.rem(8)};
      }

      & ${(): AnyStyledComponent => StyledErrorPage.Logo} {
        margin-top: ${metrics.rem(34)};
        margin-bottom: ${metrics.rem(10)};
      }

      & ${(): AnyStyledComponent => StyledErrorPage.Title} {
        margin-bottom: ${metrics.rem(16)};
      }

      & ${(): AnyStyledComponent => StyledErrorPage.ErrorContainer} {
        margin-bottom: ${metrics.rem(16)};
      }

      & ${(): AnyStyledComponent => StyledErrorPage.ContinueButton} {
        margin-bottom: ${metrics.rem(16)};
      }
    `};
  `,
  Logo: styled(Logo)`
    flex-shrink: 0;
    ${({ theme: { metrics } }) => css`
      width: ${metrics.rem(240)};
      height: auto;
    `}
  `,
  Title: styled.h1`
    text-align: center;
    flex-shrink: 0;
    ${({ theme: { colors, fonts } }) => css`
      line-height: ${fonts.fontSizes.huge + 1}px;
      ${fonts.huge({ fontFamily: Fonts.family.BOOK, color: colors.grey.darker })};
    `}
  `,
  ErrorContainer: styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    overflow: hidden;
    flex-grow: 1;
    width: 100%;
    ${({ theme: { metrics } }) => css`
      & ${(): AnyStyledComponent => StyledErrorPage.ErrorDetailContainer} {
        margin-bottom: ${metrics.rem(16)};
      }
    `}
  `,
  ErrorDetailContainer: styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    overflow: hidden;
    flex-shrink: 0;
    ${({ theme: { colors, fonts } }) => css`
      line-height: ${fonts.fontSizes.small + 1}px;
      ${fonts.small({ fontFamily: Fonts.family.BOOK, color: colors.grey.darker })};

      & ${(): AnyStyledComponent => StyledErrorPage.ErrorType} {
        margin-right: 0.5em;
      }
    `}
  `,
  ErrorType: styled.span`
    ${({ theme: { colors } }) => css`
      font-weight: bold;
      color: ${colors.error.base};
    `}
  `,
  ErrorMessage: styled.span`
    text-align: center;
  `,
  StackTraceContainer: styled.div`
    flex-grow: 1;
    ${({ theme: { colors, metrics } }) => css`
      width: calc(100% - ${metrics.rem(16)});
      border: ${metrics.rem(1)} solid ${colors.grey.lighter};
    `}
  `,
  StackTrace: styled(ScrollableContainer)`
    ${({ theme: { colors, fonts } }) => css`
      line-height: ${fonts.fontSizes.small + 1}px;
      ${fonts.small({ fontFamily: Fonts.family.BOOK, color: colors.grey.darker })};
    `}
  `,
  ContinueButton: styled(Button)``,
};
